import React, { Component } from 'react'
import './index.scss'
export default class App extends Component {
  componentDidMount() {
    this._isMounted = true
  }
  componentWillUnmount() {
    this._isMounted = false
  }
  constructor() {
    super()
    this.state = {
      activedTab: 0,
      pageImg: {
        imgPath: require("./img/pic.png"),
        imgHDPath: `${require("./img/pic.png")} 1x,${require("./img/pic@2x.png")} 2x,${require("./img/pic@3x.png")} 3x`,
      },
      contactList: [
        { title: '北京总部', address: '北京市海淀区车公庄西路19号外文文化创意园12A号楼', tel: '010-88540961', fax: '+86-10-88018550', Internet: 'www.greetec.com', mail: 'hr_zx@greetec.com' },
        { title: '天津分公司', address: '天津市和平区大沽北路2号津塔写字楼69层', mail: 'hr_zx@greetec.com' },
        { title: '石家庄分公司', address: '石家庄市长安区中山东路39号勒泰中心B座2307-2308', mail: 'hr_zx@greetec.com' },
        { title: '沈阳分公司', address: '沈阳市和平区和平北大街156号光大大厦14层', mail: 'hr_zx@greetec.com' },
        { title: '张家口分公司', address: '张家口市经开区长江时代A座13层', mail: 'hr_zx@greetec.com' },
        { title: '郑州分公司', address: '郑州市中原区中原中路171号万达广场写字楼A座21、24层', mail: 'ouhaitao@greetec.com' },
        { title: '山西分公司', address: '山西省太原市小店区君威国际金融中心A座1302', mail: 'ouhaitao@greetec.com' },
        { title: '武汉分公司', address: '武汉市江汉区建设大道568号新世界国贸大厦3402室', mail: 'ouhaitao@greetec.com' },
        { title: '湖南分公司', address: '长沙市芙蓉区韶山北路216号维一星城国际27楼 ／ 株洲市天元区长江北路16号招标大厦10楼1102室', mail: 'yangdongxu@greetec.com' },
        { title: '江西分公司', address: '南昌市红谷滩新区红谷中大道1402号浦发大厦6楼', mail: 'yangdongxu@greetec.com' },
        { title: '广州分公司', address: '广州市天河区水荫路115号天溢大厦A座五层501', mail: 'yangdongxu@greetec.com' },
        { title: '深圳分公司', address: '深圳市福田区深南中路2002号中核大厦八楼808', mail: 'yangdongxu@greetec.com' },
        { title: '广西分公司', address: '南宁市青秀区民族大道146号三祺广场1702A', mail: 'yangdongxu@greetec.com' },
        { title: '海南分公司', address: '海口市龙华区海秀中路57号海垦广场综合楼5层B501室', mail: 'yangdongxu@greetec.com' },
        { title: '上海分公司', address: '上海市浦东新区世纪大道88号金茂大厦901室', mail: 'xieyan@greetec.com' },
        { title: '江苏分公司', address: '南京市秦淮区中山南路1号38层', mail: 'xieyan@greetec.com' },
        { title: '山东分公司', address: '济南市市中区胜利大街56号山东书城培训楼10层', mail: 'xieyan@greetec.com' },
        { title: '浙江分公司', address: '杭州市江干区钱江新城五星路198号瑞晶国际大厦3403F', mail: 'xieyan@greetec.com' },
        { title: '安徽分公司', address: '合肥市包河区徽州大道838号平安国际金融中心1306室', mail: 'xieyan@greetec.com' },
        { title: '西安分公司', address: '西安市高新区唐延路11号禾盛京广中心D栋6层', mail: 'caoyingying@greetec.com' },
        { title: '甘肃分公司', address: '甘肃省兰州市七里河区西津西路16号兰州中心写字楼29楼', mail: 'caoyingying@greetec.com' },
        { title: '青海分公司', address: '西宁市城西区西川南路76号4号楼34层13407室', mail: 'caoyingying@greetec.com' },
        { title: '新疆分公司', address: '新疆乌鲁木齐市天山区新华北路165号中信银行大厦22层ABCDE室', mail: 'caoyingying@greetec.com' },
        { title: '宁夏分公司', address: '宁夏银川市兴庆区凤凰北街新华保险大厦2808室', mail: 'caoyingying@greetec.com' },
        { title: '成都分公司', address: '成都市锦江区橡树林路189号瑞升国际大厦26F', mail: 'wangke@greetec.com' },
        { title: '重庆分公司', address: '重庆市江北区庆云路1号国金中心T1栋20楼2-3号', mail: 'wangke@greetec.com' },
        { title: '云南分公司', address: '昆明市五华区东风西路123号三合商利写字楼16楼', mail: 'wangke@greetec.com' },
        { title: '贵州分公司', address: '贵阳市观山湖区金融城金融ONE座13楼', mail: 'wangke@greetec.com' },
        { title: '雄安分公司', address: '保定市容城县雄安媒体中心205室', mail: 'zhushuang@greetec.com' },
        { title: '苏州分公司', address: '苏州市工业园区星海街198号星海大厦东5楼', mail: 'chensijia@greetec.com' },
      ]
    }
  }
  tabChange(e, index) {
    e.preventDefault()
    window.scrollTo(0, 0)
    this.setState({
      activedTab: index
    })
  }

  render() {
    return (
      <React.Fragment>
        <div className="campus-recruiting">
          {
            this.state.activedTab === 0
              ?
              <div>
                <img src={this.state.pageImg.imgPath} srcSet={this.state.pageImg.imgHDPath} alt="" style={{ width: '100%' }} />
                <button className="contact-button" onClick={(e) => this.tabChange(e, 1)}>联系方式</button>
              </div>
              :
              <ul className="contact-us">
                {
                  this.state.contactList.map((item, index) =>
                    <li key={index} className="contact-info">
                      <div>{item.title}</div>
                      <table>
                        <tbody>
                          <tr>
                            <td>地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址</td>
                            <td>{item.address}</td>
                          </tr>
                          {
                            item.tel && <tr>
                              <td>电&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;话</td>
                              <td>
                                <a href={"tel:" + item.tel} style={{ color: '#0A5992', textDecoration: 'underline' }}>{item.tel}</a>
                              </td>
                            </tr>
                          }
                          {
                            item.fax && <tr>
                              <td>传&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;真</td>
                              <td>{item.fax}</td>
                            </tr>
                          }
                          {
                            item.Internet && <tr>
                              <td>网&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址</td>
                              <td>{item.Internet}</td>
                            </tr>
                          }
                          <tr>
                            <td>电子邮箱</td>
                            <td>{item.mail}</td>
                          </tr>
                        </tbody>
                      </table>
                    </li>
                  )
                }
              </ul>
          }
        </div>
      </React.Fragment >
    );
  }
}
